import React from "react";
import { useSmartProp } from "@smartfire/js-block-engine";
import {
  Button,
  PanelBody,
  PanelRow,
  TextControl,
} from "@wordpress/components";
import DeleteIcon from "@mui/icons-material/Delete";

export const Inspector = () => {
  const [options, setOptions] = useSmartProp("options");

  function addOption() {
    const copy = [...options];
    copy.push({
      label: "",
      value: "",
    });
    setOptions(copy);
  }

  function deleteOption(i) {
    let copy = [...options];
    copy.splice(i, 1);
    setOptions(copy);
  }

  function updateOption(i, value, prop) {
    let copy = [...options];
    copy[i][prop] = value;
    setOptions(copy);
  }

  return (
    <>
      <PanelBody title="Options" initialOpen={true}>
        <PanelRow>
          <Button
            isPrimary={true}
            onClick={() => addOption()}
            style={{ marginBottom: "20px" }}
          >
            Add an option
          </Button>
        </PanelRow>
        {options &&
          options.length > 0 &&
          options.map((option, i) => (
            <PanelBody key={i} title={"Option " + (i + 1)} initialOpen={false}>
              <PanelRow>
                <TextControl
                  label="Label"
                  value={option.label}
                  onChange={(value) => updateOption(i, value, "label")}
                />
              </PanelRow>
              <PanelRow>
                <TextControl
                  label="Value"
                  value={option.value}
                  onChange={(value) => updateOption(i, value, "value")}
                />
              </PanelRow>
              <PanelRow>
                <Button isPrimary={true} onClick={() => deleteOption(i)}>
                  <DeleteIcon />
                  Delete
                </Button>
              </PanelRow>
            </PanelBody>
          ))}
      </PanelBody>
    </>
  );
};

export default Inspector;
